"use strict";
/**
 * Formula Box for 'Super Aluminium' trough system
 * It's for a calculation of guiding trough system if the e-chain is gliding or rolling
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcMinBauraumFuehrungsrinneHoehe_mm = exports.calcMinBauraumFuehrungsrinneLaenge_mm = exports.calcMinBauraumFuehrungsrinneBreite_mm = exports.calcFuehrungsrinneStahlOhneFPMod_AnzahlMontageSets_TA1Q = exports.calcFuehrungsrinneStahlOhneFPMod_AnzahlMitGLS_TG1Q = exports.calcFuehrungsrinneStahlOhneFPMod_AnzahlOhneGLS_TW1Q = exports.calcFuehrungsrinneStahlOhneFPMod_LaengeMitGLS_TG1_mm = exports.roundFuehrungsrinneStahlOhneFPMod_LaengeOhneGLS_TW1_mm = exports.calcFuehrungsrinneStahlOhneFPMod_LaengeOhneGLS_TW1_mm = exports.roundFuehrungsrinneStahlOhneFPMod_Laengegesamt_TL_mm = exports.calcFuehrungsrinneStahlOhneFPMod_Laengegesamt_TL_mm = exports.calcFuehrungsrinneStahl_AnzahlMontageSets_TA1Q = exports.calcFuehrungsrinneStahl_AnzahlMitGLS_TG1Q = exports.calcFuehrungsrinneStahl_AnzahlFP_TFP1Q = exports.calcFuehrungsrinneStahl_AnzahlOhneGLS_TW1Q = exports.calcFuehrungsrinneStahl_LaengeMitGLS_TG1_mm = exports.calcFuehrungsrinneStahl_LaengeFP_TFP1_mm = exports.roundFuehrungsrinneStahl_LaengeOhneGLS_TW1_mm = exports.calcFuehrungsrinneStahl_LaengeOhneGLS_TW1_mm = exports.roundFuehrungsrinneStahl_Laengegesamt_TL_mm = exports.calcFuehrungsrinneStahl_Laengegesamt_TL_mm = exports.calcFuehrungsrinneSuperAlu_AnzahlMontageSets_TA1Q = exports.calcFuehrungsrinneSuperAlu_AnzahlMitGLS_TG1Q = exports.calcFuehrungsrinneSuperAlu_AnzahlOhneGLS_TW1Q = exports.calcFuehrungsrinneSuperAlu_LaengeMitGLS_TG1_mm = exports.roundFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm = exports.calcFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm = exports.roundFuehrungsrinneSuperAlu_Laengegesamt_TL_mm = exports.calcFuehrungsrinneSuperAlu_Laengegesamt_TL_mm = void 0;
/**
 * Calculates the total trough length.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   verfahrweg_S_mm                    total travel length / in mm
 * @param   kettenbahnhofschraege_X1_mm        distance of e-chain in endposition right (see catalog sketch) from center line 1st link of moving end to center line axis radius / in mm
 * @param   radiusAussen_D1_mm                 distance of e-chain in endposition right (see catalog sketch) from center line axis radius to absolute outside e-chain / in mm
 * @returns uroundRinnenlaengeGesamt_TL_mm     unround total trough length / in mm
 * @returns rinnenlaengeGesamt_TL_mm           round up to next logical dimension of full support distance / in mm
 */
const calcFuehrungsrinneSuperAlu_Laengegesamt_TL_mm = (verfahrweg_S_mm, kettenbahnhofschraege_X1_mm, radiusAussen_D1_mm) => {
    const kettenbahnhoftoleranz_X1t_mm = 50;
    return verfahrweg_S_mm + kettenbahnhofschraege_X1_mm + kettenbahnhoftoleranz_X1t_mm + radiusAussen_D1_mm;
};
exports.calcFuehrungsrinneSuperAlu_Laengegesamt_TL_mm = calcFuehrungsrinneSuperAlu_Laengegesamt_TL_mm;
const roundFuehrungsrinneSuperAlu_Laengegesamt_TL_mm = (uroundRinnenlaengeGesamt_TL_mm, stuetzabstand_SD_mm) => {
    const quotitentRinnenlaengeGesamt_TL = uroundRinnenlaengeGesamt_TL_mm / stuetzabstand_SD_mm;
    return Math.ceil(quotitentRinnenlaengeGesamt_TL) * stuetzabstand_SD_mm;
};
exports.roundFuehrungsrinneSuperAlu_Laengegesamt_TL_mm = roundFuehrungsrinneSuperAlu_Laengegesamt_TL_mm;
/**
 * Calculates the length of the trough without glide bars, no consideration if an additional half
 * part is needed.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   radiusAussen_D1_mm                 distance of e-chain in endposition right (see catalog sketch) from center line axis radius to absolute outside e-chain / in mm
 * @param   kettenbahnhof_K2_mm                length of e-chain in endposition right (see catalog sketch) from center line 1st links of moving end to tangential outlet of bending radius / in mm
 * @param   kettenlaengeOhneAE_LK_mm           total length of e-chain without mounting brackets / in mm
 * @returns uroundLaengeRinneOhneGLS_TW1_mm    unround length of trough without glide bars / in mm
 * @returns laengeRinneOhneGLS_TW1_mm          round off to next logical dimension of full support distance / in mm
 */
const calcFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm = (kettenlaengeOhneAE_LK_mm, kettenbahnhof_K2_mm, radiusAussen_D1_mm) => {
    return kettenlaengeOhneAE_LK_mm - kettenbahnhof_K2_mm + radiusAussen_D1_mm;
};
exports.calcFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm = calcFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm;
const roundFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm = (uroundlaengeRinneOhneGLS_TW1_mm, stuetzabstand_SD_mm) => {
    const quotitentRinneOhneGLS_TW1 = uroundlaengeRinneOhneGLS_TW1_mm / stuetzabstand_SD_mm;
    return Math.floor(quotitentRinneOhneGLS_TW1) * stuetzabstand_SD_mm;
};
exports.roundFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm = roundFuehrungsrinneSuperAlu_LaengeOhneGLS_TW1_mm;
/**
 * Calculates the length of the trough include glide bars, no consideration if an additional half
 * part is needed.
 *
 * Parameters from the box itself
 *
 * @param   rinnenlaengeGesamt_TL_mm      total trough length / in mm
 * @param   laengeRinneOhneGLS_TW1_mm     length of trough without glide bars / in mm
 * @returns laengeRinneMitGLS_TG1_mm      length of trough include glide bars / in mm
 */
const calcFuehrungsrinneSuperAlu_LaengeMitGLS_TG1_mm = (rinnenlaengeGesamt_TL_mm, laengeRinneOhneGLS_TW1_mm) => {
    return rinnenlaengeGesamt_TL_mm - laengeRinneOhneGLS_TW1_mm;
};
exports.calcFuehrungsrinneSuperAlu_LaengeMitGLS_TG1_mm = calcFuehrungsrinneSuperAlu_LaengeMitGLS_TG1_mm;
/**
 * Calculates the quantity of the trough without glide bars, no consideration if an additional half
 * part is needed.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   stuetzabstand_SD_mm           support distance, means distance between assembly kits / in mm
 *
 * Parameters from the box itself
 * @param   laengeRinneOhneGLS_TW1_mm     length of trough without glide bars / in mm
 * @returns anzahlRinneOhneGLS_TW1Q       quantity of trough parts without glide bars without additional half part / no unit
 */
const calcFuehrungsrinneSuperAlu_AnzahlOhneGLS_TW1Q = (laengeRinneOhneGLS_TW1_mm, stuetzabstand_SD_mm) => {
    return laengeRinneOhneGLS_TW1_mm / stuetzabstand_SD_mm;
};
exports.calcFuehrungsrinneSuperAlu_AnzahlOhneGLS_TW1Q = calcFuehrungsrinneSuperAlu_AnzahlOhneGLS_TW1Q;
/**
 * Calculates the quantity of the trough include glide bars, no consideration if an additional half
 * part is needed.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   stuetzabstand_SD_mm           support distance, means distance between assembly kits / in mm
 *
 * Parameters from the box itself
 * @param   laengeRinneMitGLS_TG1_mm      length of trough include glide bars / in mm
 * @returns anzahlRinneMitGLS_TG1Q        quantity of trough parts include glide bars without additional half part / no unit
 */
const calcFuehrungsrinneSuperAlu_AnzahlMitGLS_TG1Q = (laengeRinneMitGLS_TG1_mm, stuetzabstand_SD_mm) => {
    return laengeRinneMitGLS_TG1_mm / stuetzabstand_SD_mm;
};
exports.calcFuehrungsrinneSuperAlu_AnzahlMitGLS_TG1Q = calcFuehrungsrinneSuperAlu_AnzahlMitGLS_TG1Q;
/**
 * Calculates the quantity of assembly kits with consideration if an additional half part is needed.
 *
 * Parameters from the box itself
 *
 * @param   anzahlRinneOhneGLS_TW1Q       quantity of trough parts without glide bars without additional half part / no unit
 * @param   anzahlRinneMitGLS_TG1Q        quantity of trough parts include glide bars without additional half part / no unit
 * @returns anzahlMontagesets_TA1Q        quantity of assembly kits / no unit
 */
const calcFuehrungsrinneSuperAlu_AnzahlMontageSets_TA1Q = (anzahlRinneOhneGLS_TW1Q, anzahlRinneMitGLS_TG1Q) => {
    // calculate quantity of needed assembly kits "TA1Q", number 1 is always fixed
    return anzahlRinneOhneGLS_TW1Q + anzahlRinneMitGLS_TG1Q + 1;
};
exports.calcFuehrungsrinneSuperAlu_AnzahlMontageSets_TA1Q = calcFuehrungsrinneSuperAlu_AnzahlMontageSets_TA1Q;
/**
 * Formula Box for 'Standard Stahlrinne' trough system
 * It's for a calculation of guiding trough system if the e-chain is gliding or rolling
 */
/**
 * Calculates the total trough length.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   verfahrweg_S_mm                    total travel length / in mm
 * @param   kettenbahnhofschraege_X1_mm        distance of e-chain in endposition right (see catalog sketch) from center line 1st link of moving end to center line axis radius / in mm
 * @param   radiusAussen_D1_mm                 distance of e-chain in endposition right (see catalog sketch) from center line axis radius to absolute outside e-chain / in mm
 * @returns uroundRinnenlaengeGesamt_TL_mm     unround total trough length / in mm
 * @returns quotitentRinnenlaengeGesamt_TL     quotient of unround trough length and next logical dimension of half support distance / no unit
 * @returns rinnenlaengeGesamt_TL_mm           round up to next logical dimension of half support distance / in mm
 */
const calcFuehrungsrinneStahl_Laengegesamt_TL_mm = (verfahrweg_S_mm, kettenbahnhofschraege_X1_mm, radiusAussen_D1_mm) => {
    const kettenbahnhoftoleranz_X1t_mm = 50;
    return verfahrweg_S_mm + kettenbahnhofschraege_X1_mm + kettenbahnhoftoleranz_X1t_mm + radiusAussen_D1_mm;
};
exports.calcFuehrungsrinneStahl_Laengegesamt_TL_mm = calcFuehrungsrinneStahl_Laengegesamt_TL_mm;
const roundFuehrungsrinneStahl_Laengegesamt_TL_mm = (uroundRinnenlaengeGesamt_TL_mm, stuetzabstand_SD_mm) => {
    const quotitentRinnenlaengeGesamt_TL = uroundRinnenlaengeGesamt_TL_mm / stuetzabstand_SD_mm;
    return Math.ceil(quotitentRinnenlaengeGesamt_TL) * stuetzabstand_SD_mm;
};
exports.roundFuehrungsrinneStahl_Laengegesamt_TL_mm = roundFuehrungsrinneStahl_Laengegesamt_TL_mm;
/**
 * Calculates the length of the trough without glide bars, no consideration if an additional half
 * part is needed.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   radiusAussen_D1_mm                 distance of e-chain in endposition right (see catalog sketch) from center line axis radius to absolute outside e-chain / in mm
 * @param   kettenbahnhof_K2_mm                length of e-chain in endposition right (see catalog sketch) from center line 1st links of moving end to tangential outlet of bending radius / in mm
 * @param   kettenlaengeOhneAE_LK_mm           total length of e-chain without mounting brackets / in mm
 * @returns uroundLaengeRinneOhneGLS_TW1_mm    unround length of trough without glide bars / in mm
 * @returns laengeRinneOhneGLS_TW1_mm          round to next logical dimension of full support distance / in mm
 */
const calcFuehrungsrinneStahl_LaengeOhneGLS_TW1_mm = (kettenlaengeOhneAE_LK_mm, kettenbahnhof_K2_mm, radiusAussen_D1_mm) => {
    return kettenlaengeOhneAE_LK_mm - kettenbahnhof_K2_mm + radiusAussen_D1_mm;
};
exports.calcFuehrungsrinneStahl_LaengeOhneGLS_TW1_mm = calcFuehrungsrinneStahl_LaengeOhneGLS_TW1_mm;
const roundFuehrungsrinneStahl_LaengeOhneGLS_TW1_mm = (uroundlaengeRinneOhneGLS_TW1_mm, stuetzabstand_SD_mm) => {
    const quotitentRinneOhneGLS_TW1 = uroundlaengeRinneOhneGLS_TW1_mm / stuetzabstand_SD_mm;
    return Math.round(quotitentRinneOhneGLS_TW1) * stuetzabstand_SD_mm;
};
exports.roundFuehrungsrinneStahl_LaengeOhneGLS_TW1_mm = roundFuehrungsrinneStahl_LaengeOhneGLS_TW1_mm;
/**
 * Calculates the length of the trough for fixed point module
 *
 * Parameters from the box itself
 *
 * @param   stuetzabstand_SD_mm        support distance, means distance between assembly kits / in mm
 * @returns laengeRinneFP_TFP1_mm      length of fixed point module / in mm
 */
const calcFuehrungsrinneStahl_LaengeFP_TFP1_mm = (stuetzabstand_SD_mm) => {
    return stuetzabstand_SD_mm;
};
exports.calcFuehrungsrinneStahl_LaengeFP_TFP1_mm = calcFuehrungsrinneStahl_LaengeFP_TFP1_mm;
/**
 * Calculates the length of the trough include glide bars.
 *
 * Parameters from the box itself
 *
 * @param   rinnenlaengeGesamt_TL_mm      total trough length / in mm
 * @param   laengeRinneOhneGLS_TW1_mm     length of trough without glide bars / in mm
 * @param   laengeRinneFP_TFP1_mm         length of fixed point module / in mm
 * @returns laengeRinneMitGLS_TG1_mm      length of trough include glide bars / in mm
 */
const calcFuehrungsrinneStahl_LaengeMitGLS_TG1_mm = (rinnenlaengeGesamt_TL_mm, laengeRinneOhneGLS_TW1_mm, laengeRinneFP_TFP1_mm) => {
    return rinnenlaengeGesamt_TL_mm - laengeRinneOhneGLS_TW1_mm - laengeRinneFP_TFP1_mm;
};
exports.calcFuehrungsrinneStahl_LaengeMitGLS_TG1_mm = calcFuehrungsrinneStahl_LaengeMitGLS_TG1_mm;
/**
 * Calculates the quantity of the trough without glide bars.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   stuetzabstand_SD_mm           support distance, means distance between assembly kits / in mm
 *
 * Parameters from the box itself
 * @param   laengeRinneOhneGLS_TW1_mm     length of trough without glide bars / in mm
 * @param   laengeRinneFP_TFP1_mm         length of fixed point module / in mm
 * @returns anzahlRinneOhneGLS_TW1Q       quantity of trough parts without glide bars without additional half part / no unit
 */
const calcFuehrungsrinneStahl_AnzahlOhneGLS_TW1Q = (laengeRinneOhneGLS_TW1_mm, laengeRinneFP_TFP1_mm, stuetzabstand_SD_mm) => {
    return laengeRinneOhneGLS_TW1_mm / stuetzabstand_SD_mm;
};
exports.calcFuehrungsrinneStahl_AnzahlOhneGLS_TW1Q = calcFuehrungsrinneStahl_AnzahlOhneGLS_TW1Q;
/**
 * Calculates the quantity of the fixed point module.
 *
 * @returns anzahlRinneFestpunkt_TFP1Q       quantity of fixed point module / no unit
 */
const calcFuehrungsrinneStahl_AnzahlFP_TFP1Q = () => {
    return 1;
};
exports.calcFuehrungsrinneStahl_AnzahlFP_TFP1Q = calcFuehrungsrinneStahl_AnzahlFP_TFP1Q;
/**
 * Calculates the quantity of the trough include glide bars, no consideration if an additional half
 * part is needed.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   stuetzabstand_SD_mm           support distance, means distance between assembly kits / in mm
 *
 * Parameters from the box itself
 * @param   laengeRinneMitGLS_TG1_mm      length of trough include glide bars / in mm
 * @returns anzahlRinneMitGLS_TG1Q        quantity of trough parts include glide bars without additional half part / no unit
 */
const calcFuehrungsrinneStahl_AnzahlMitGLS_TG1Q = (laengeRinneMitGLS_TG1_mm, stuetzabstand_SD_mm) => {
    return laengeRinneMitGLS_TG1_mm / stuetzabstand_SD_mm;
};
exports.calcFuehrungsrinneStahl_AnzahlMitGLS_TG1Q = calcFuehrungsrinneStahl_AnzahlMitGLS_TG1Q;
/**
 * Calculates the quantity of assembly kits with consideration if an additional half part is needed.
 *
 * Parameters from the box itself
 *
 * @param   anzahlRinneOhneGLS_TW1Q       quantity of trough parts without glide bars without additional half part / no unit
 * @param   anzahlRinneFP_TFP1Q
 * @param   anzahlRinneMitGLS_TG1Q        quantity of trough parts include glide bars without additional half part / no unit
 * @returns anzahlMontagesets_TA1Q        quantity of assembly kits / no unit
 */
const calcFuehrungsrinneStahl_AnzahlMontageSets_TA1Q = (anzahlRinneOhneGLS_TW1Q, anzahlRinneFP_TFP1Q, anzahlRinneMitGLS_TG1Q) => {
    return anzahlRinneOhneGLS_TW1Q + anzahlRinneFP_TFP1Q + anzahlRinneMitGLS_TG1Q + 1;
};
exports.calcFuehrungsrinneStahl_AnzahlMontageSets_TA1Q = calcFuehrungsrinneStahl_AnzahlMontageSets_TA1Q;
/**
 * Formula Box for 'Standard Stahlrinne' trough system without fixed point module
 * It's for a calculation of guiding trough system if the e-chain is gliding or rolling
 */
/**
 * Calculates the total trough length.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   verfahrweg_S_mm                    total travel length / in mm
 * @param   kettenbahnhofschraege_X1_mm        distance of e-chain in endposition right (see catalog sketch) from center line 1st link of moving end to center line axis radius / in mm
 * @param   radiusAussen_D1_mm                 distance of e-chain in endposition right (see catalog sketch) from center line axis radius to absolute outside e-chain / in mm
 * @returns uroundRinnenlaengeGesamt_TL_mm     unround total trough length / in mm
 * @returns quotitentRinnenlaengeGesamt_TL     quotient of unround trough length and next logical dimension of half support distance / no unit
 * @returns rinnenlaengeGesamt_TL_mm           round up to next logical dimension of half support distance / in mm
 */
const calcFuehrungsrinneStahlOhneFPMod_Laengegesamt_TL_mm = (verfahrweg_S_mm, kettenbahnhofschraege_X1_mm, radiusAussen_D1_mm) => {
    const kettenbahnhoftoleranz_X1t_mm = 50;
    return verfahrweg_S_mm + kettenbahnhofschraege_X1_mm + kettenbahnhoftoleranz_X1t_mm + radiusAussen_D1_mm;
};
exports.calcFuehrungsrinneStahlOhneFPMod_Laengegesamt_TL_mm = calcFuehrungsrinneStahlOhneFPMod_Laengegesamt_TL_mm;
const roundFuehrungsrinneStahlOhneFPMod_Laengegesamt_TL_mm = (uroundRinnenlaengeGesamt_TL_mm, stuetzabstand_SD_mm) => {
    const quotitentRinnenlaengeGesamt_TL = uroundRinnenlaengeGesamt_TL_mm / stuetzabstand_SD_mm;
    return Math.ceil(quotitentRinnenlaengeGesamt_TL) * stuetzabstand_SD_mm;
};
exports.roundFuehrungsrinneStahlOhneFPMod_Laengegesamt_TL_mm = roundFuehrungsrinneStahlOhneFPMod_Laengegesamt_TL_mm;
/**
 * Calculates the length of the trough without glide bars, no consideration if an additional half
 * part is needed.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   radiusAussen_D1_mm                 distance of e-chain in endposition right (see catalog sketch) from center line axis radius to absolute outside e-chain / in mm
 * @param   kettenbahnhof_K2_mm                length of e-chain in endposition right (see catalog sketch) from center line 1st links of moving end to tangential outlet of bending radius / in mm
 * @param   kettenlaengeOhneAE_LK_mm           total length of e-chain without mounting brackets / in mm
 * @returns uroundLaengeRinneOhneGLS_TW1_mm    unround length of trough without glide bars / in mm
 * @returns laengeRinneOhneGLS_TW1_mm          round to next logical dimension of full support distance / in mm
 */
const calcFuehrungsrinneStahlOhneFPMod_LaengeOhneGLS_TW1_mm = (kettenlaengeOhneAE_LK_mm, kettenbahnhof_K2_mm, radiusAussen_D1_mm) => {
    return kettenlaengeOhneAE_LK_mm - kettenbahnhof_K2_mm + radiusAussen_D1_mm;
};
exports.calcFuehrungsrinneStahlOhneFPMod_LaengeOhneGLS_TW1_mm = calcFuehrungsrinneStahlOhneFPMod_LaengeOhneGLS_TW1_mm;
const roundFuehrungsrinneStahlOhneFPMod_LaengeOhneGLS_TW1_mm = (uroundlaengeRinneOhneGLS_TW1_mm, stuetzabstand_SD_mm) => {
    const quotitentRinneOhneGLS_TW1 = uroundlaengeRinneOhneGLS_TW1_mm / stuetzabstand_SD_mm;
    return Math.round(quotitentRinneOhneGLS_TW1) * stuetzabstand_SD_mm;
};
exports.roundFuehrungsrinneStahlOhneFPMod_LaengeOhneGLS_TW1_mm = roundFuehrungsrinneStahlOhneFPMod_LaengeOhneGLS_TW1_mm;
/**
 * Calculates the length of the trough include glide bars.
 *
 * Parameters from the box itself
 *
 * @param   rinnenlaengeGesamt_TL_mm      total trough length / in mm
 * @param   laengeRinneOhneGLS_TW1_mm     length of trough without glide bars / in mm
 * @returns laengeRinneMitGLS_TG1_mm      length of trough include glide bars / in mm
 */
const calcFuehrungsrinneStahlOhneFPMod_LaengeMitGLS_TG1_mm = (rinnenlaengeGesamt_TL_mm, laengeRinneOhneGLS_TW1_mm) => {
    return rinnenlaengeGesamt_TL_mm - laengeRinneOhneGLS_TW1_mm;
};
exports.calcFuehrungsrinneStahlOhneFPMod_LaengeMitGLS_TG1_mm = calcFuehrungsrinneStahlOhneFPMod_LaengeMitGLS_TG1_mm;
/**
 * Calculates the quantity of the trough without glide bars.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   stuetzabstand_SD_mm           support distance, means distance between assembly kits / in mm
 *
 * Parameters from the box itself
 * @param   laengeRinneOhneGLS_TW1_mm     length of trough without glide bars / in mm
 * @returns anzahlRinneOhneGLS_TW1Q       quantity of trough parts without glide bars without additional half part / no unit
 */
const calcFuehrungsrinneStahlOhneFPMod_AnzahlOhneGLS_TW1Q = (laengeRinneOhneGLS_TW1_mm, stuetzabstand_SD_mm) => {
    return laengeRinneOhneGLS_TW1_mm / stuetzabstand_SD_mm;
};
exports.calcFuehrungsrinneStahlOhneFPMod_AnzahlOhneGLS_TW1Q = calcFuehrungsrinneStahlOhneFPMod_AnzahlOhneGLS_TW1Q;
/**
 * Calculates the quantity of the trough include glide bars, no consideration if an additional half
 * part is needed.
 *
 * Parameters from iQuote e-chain selection
 *
 * @param   stuetzabstand_SD_mm           support distance, means distance between assembly kits / in mm
 *
 * Parameters from the box itself
 * @param   laengeRinneMitGLS_TG1_mm      length of trough include glide bars / in mm
 * @returns anzahlRinneMitGLS_TG1Q        quantity of trough parts include glide bars without additional half part / no unit
 */
const calcFuehrungsrinneStahlOhneFPMod_AnzahlMitGLS_TG1Q = (laengeRinneMitGLS_TG1_mm, stuetzabstand_SD_mm) => {
    return laengeRinneMitGLS_TG1_mm / stuetzabstand_SD_mm;
};
exports.calcFuehrungsrinneStahlOhneFPMod_AnzahlMitGLS_TG1Q = calcFuehrungsrinneStahlOhneFPMod_AnzahlMitGLS_TG1Q;
/**
 * Calculates the quantity of assembly kits with consideration if an additional half part is needed.
 *
 * Parameters from the box itself
 *
 * @param   anzahlRinneOhneGLS_TW1Q       quantity of trough parts without glide bars without additional half part / no unit
 * @param   anzahlRinneMitGLS_TG1Q        quantity of trough parts include glide bars without additional half part / no unit
 * @returns anzahlMontagesets_TA1Q        quantity of assembly kits / no unit
 */
const calcFuehrungsrinneStahlOhneFPMod_AnzahlMontageSets_TA1Q = (anzahlRinneOhneGLS_TW1Q, anzahlRinneMitGLS_TG1Q) => {
    return anzahlRinneOhneGLS_TW1Q + anzahlRinneMitGLS_TG1Q + 1;
};
exports.calcFuehrungsrinneStahlOhneFPMod_AnzahlMontageSets_TA1Q = calcFuehrungsrinneStahlOhneFPMod_AnzahlMontageSets_TA1Q;
/**
 * Berechnet die minimale Bauraumbreite in mm.
 *
 * @param zusBreiteFRBefestigung_mm Zusätzliche Breite der Führungsrinne.
 * Die zusätzliche Breite der Führungsrinne ist die Gesamtbreite der Führungsrinne
 * inklusive Klemmschuh des Montage Sets - Ba.
 * Ba ist die Außenbreite der e-kette.
 * @param ketteAussenbreite_mm Die Ketten Außenbreite.
 * @returns Die minimale Bauraumbreite der Führungsrinne in mm.
 */
const calcMinBauraumFuehrungsrinneBreite_mm = (zusBreiteFRBefestigung_mm, ketteAussenbreite_mm) => {
    const sicherheitsabstand_mm = 25;
    return zusBreiteFRBefestigung_mm + ketteAussenbreite_mm + sicherheitsabstand_mm;
};
exports.calcMinBauraumFuehrungsrinneBreite_mm = calcMinBauraumFuehrungsrinneBreite_mm;
/**
 * Berechnet die minimale Bauraumlänge in mm.
 *
 * @param rinnenlaengeGesamt_TL_mm Die berechnete Gesamtlänge der Führungsrinne
 * @returns Die minimale Bauraumlänge der Führungsrinne in mm.
 */
const calcMinBauraumFuehrungsrinneLaenge_mm = (rinnenlaengeGesamt_TL_mm) => {
    const sicherheitsabstand_mm = 250;
    return rinnenlaengeGesamt_TL_mm + sicherheitsabstand_mm;
};
exports.calcMinBauraumFuehrungsrinneLaenge_mm = calcMinBauraumFuehrungsrinneLaenge_mm;
/**
 * Berechnet die minimale Bauraumhöhe in mm.
 *
 * @param rinneAuflageHoehe_mm Die Höhe vom Boden bis zur Fläche auf die, die Führungsrinne aufliegt.
 * @param ketteAussenhoehe_mm Die Außenhöhe der e-kette.
 * @param ketteHoeheVorspannung_mm Die Höhe der Vorspannung. Die Höhe der Vorspannung ist die Höhe, die zur Kettenhöhe hinzukommt.
 * @param ketteBiegeradius_mm Der Biegeradius der e-kette.
 * @returns Die minimale Bauraumhöhe der Führungsrinne in mm.
 */
const calcMinBauraumFuehrungsrinneHoehe_mm = (rinneAuflageHoehe_mm, ketteAussenhoehe_mm, ketteHoeheVorspannung_mm, ketteBiegeradius_mm) => {
    return rinneAuflageHoehe_mm + ketteAussenhoehe_mm + ketteHoeheVorspannung_mm + 2 * ketteBiegeradius_mm;
};
exports.calcMinBauraumFuehrungsrinneHoehe_mm = calcMinBauraumFuehrungsrinneHoehe_mm;
//# sourceMappingURL=fuehrungsrinne.js.map